"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatFeature = void 0;
const ChatFeature = exports.ChatFeature = {
  /** Turns on a genesys widget on the site. */
  UseGenesysWidget: '20B940FC-8064-45F4-BFC9-45D5E193F3DD',
  /** Turns on chatbot ANNA */
  UseNewBotChat: '986DF7FE-88E1-4742-B77F-43DC8B3D2F76',
  /** Turns on Genesys web messenger on the site. */
  UseWebMessenger: '5572F655-0F6D-4D81-8EAD-05AB7474B309'
};
